import ReactSelect from 'react-select';

import styled from 'styled-components';

import { FontScaleName, getFontScale } from 'themes/mixins/getFontScale';

import { SelectMotives, pickMotive } from './selectMotives';

export type StyledSelectProps = {
  scale?: FontScaleName;
  motive?: SelectMotives;
};

const Container = styled.div<StyledSelectProps>`
  display: flex;
  position: relative;

  ${getFontScale}
  ${({ motive }) => motive && pickMotive(motive)};
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;

  height: 1.9rem;
`;

const HelperText = styled.div``;

const Select = styled(ReactSelect)`
  width: 100%;
`;

export { Container, Header, Select, HelperText, InnerContainer };
